import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserOrgService {

  private orgIdSubject = new BehaviorSubject<string | null>(null);

  // Expose an observable of the org ID
  orgId$ = this.orgIdSubject.asObservable();

  constructor() { //to preservce the organisationId on refresh(Use case- to pass organisationId for staffOnBoarding)
    const storedOrgId = sessionStorage.getItem('orgId');
    if (storedOrgId && sessionStorage.getItem('LOGIN')) {
      this.orgIdSubject.next(storedOrgId);
    }
  }

  // Method to set the org ID (e.g., on login)
  setOrgId(orgId: string) {
    this.orgIdSubject.next(orgId);
    sessionStorage.setItem('orgId', orgId); // Persist to localStorage
  }

  // Method to clear the org ID (e.g., on logout)
  clearOrgId() {
    this.orgIdSubject.next(null);
    sessionStorage.removeItem('orgId'); // Clear from localStorage
  }

  getSelectedOrg(): string | null {
    let orgIds =  this.orgIdSubject.getValue();
    return orgIds ? orgIds: null
  }

  // Method to get the current org ID value
  getOrgId(): string | null {
    return this.orgIdSubject.getValue();
  }
}
